var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __spreadArrays = this && this.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
    s += arguments[i].length;
  }

  for (var r = Array(s), k = 0, i = 0; i < il; i++) {
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
      r[k] = a[j];
    }
  }

  return r;
};

var _a;
/** @jsx jsx */


import { jsx } from '@emotion/core';
import React from 'react';
import { FONT } from '../../../constants';
import { useLocalization } from '../../../localization';
import * as translations from '../localization';
import { breakpoints, useToggle } from '../../shared';
import { ActionArea } from './actionArea';
import FilterButton from './button';
import Link from './link';
import { Search } from './search';
var sectionStyles = (_a = {
  backgroundColor: '#f5f9fc',
  boxShadow: '0px 1px 4px 0px rgba(0, 0, 0, 0.1)',
  display: 'flex',
  padding: '12px 8px 0 16px',
  fontFamily: FONT.family
}, _a[breakpoints.medium] = {
  padding: '12px 16px 0 24px'
}, _a[breakpoints.large] = {
  padding: '12px 24px 0 32px'
}, _a);
var filtersStyles = {
  display: 'flex',
  flexWrap: 'wrap',
  flex: 1
};

function isReactFragment(variableToInspect) {
  if (variableToInspect === null || variableToInspect === undefined) {
    return false;
  }

  return variableToInspect.type === React.Fragment;
}

function unwrapFragment(node) {
  var element = node;

  if (element && isReactFragment(element)) {
    return element.props.children;
  }

  return [node];
}

export var Filters = function Filters(_a) {
  var action = _a.action,
      actions = _a.actions,
      breakAfter = _a.breakAfter,
      children = _a.children,
      onClearAll = _a.onClearAll,
      search = _a.search;
  var strings = useLocalization(translations).strings;

  var _b = useToggle(false),
      toggled = _b[0],
      toggle = _b[1];

  var _c = React.useState(0),
      count = _c[0],
      setCount = _c[1];

  var shouldShowMore = children.length > breakAfter;

  if (action) {
    console.warn('The `action` prop in Header is deprecated and will be removed in a later release. Use the plural `actions` prop instead');
  }

  var searchRef = React.createRef();
  var otherFiltersRef = children.map(function () {
    return React.createRef();
  });

  var allFiltersRef = __spreadArrays([searchRef], otherFiltersRef);

  function updateCount() {
    var newCount = allFiltersRef.reduce(function (acc, ref) {
      if (ref.current) {
        acc += ref.current.count();
      }

      return acc;
    }, 0);
    setCount(newCount);
  }

  function reset() {
    if (onClearAll) {
      onClearAll();
    }
  }

  return jsx("div", {
    css: sectionStyles
  }, jsx("div", {
    css: filtersStyles
  }, search && jsx(Search, __assign({}, search, {
    id: "search-filter",
    updateCount: updateCount,
    ref: searchRef
  })), children.map(function (filter, index) {
    return React.cloneElement(filter, {
      updateCount: updateCount,
      ref: otherFiltersRef[index],
      hidden: !toggled && index + 1 > breakAfter
    });
  }), shouldShowMore && jsx(FilterButton, {
    onClick: toggle,
    id: "show-more"
  }, toggled ? strings.filters.less : strings.filters.more), count > 0 && jsx(Link, {
    id: "pl-header-filters-clear",
    onClick: reset,
    badge: count
  }, strings.filters.clearall)), action && !actions && jsx(ActionArea, {
    appearance: action.appearance,
    icon: action.icon,
    onClick: action.onClick,
    text: action.text,
    disabled: action.disabled,
    loading: action.loading,
    popover: action.popover
  }), actions && jsx("div", {
    css: {
      display: 'flex',
      marginBottom: 12
    }
  }, React.Children.map(unwrapFragment(actions), function (action) {
    return jsx("div", {
      css: {
        marginLeft: 8
      }
    }, React.cloneElement(action, {
      size: 'small'
    }));
  })));
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/businessapp-patternlibrary/lib/components/Header/filters/filters.js
// module id = 959
// module chunks = 0